module.exports = __webpack_public_path__ + "static/img/close-button.78fe5b5f.svg";